import { render, staticRenderFns } from "./direct-messages-icon.vue?vue&type=template&id=1e185341"
import script from "./direct-messages-icon.vue?vue&type=script&lang=js"
export * from "./direct-messages-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports